let iValidate = {
    
    /**
     * 手机号格式验证
     * @param {} rule 
     * @param {*} value 
     * @param {*} callback 
     */
    phone(rule, value, callback){
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/; //正确手机号

        if (!(reg.test(value))) {
            callback(new Error('请输入正确的手机号格式'));
        }else {
            callback();
        }
    }

}

export default {
    install: function (vm) {
        vm.prototype.$iValidate = iValidate;
    }
}